export default "__VITE_ASSET__2sIWaj4___"